import OptionalTextAreaInput from "components/ValidatedFields/OptionalTextAreaInput";
import React from "react";
import { type FreefieldInputProps } from "shared/utils/freeFields/models";

const FreefieldTextMultiLine = (props: FreefieldInputProps) => {
  const [text, setText] = React.useState(props.initialValue ?? "");

  return <OptionalTextAreaInput
    value={text}
    onChange={(value) => { setText(value.toString()); }}
    onBlur={() => { props.onChange(text); }}
    maxLength={serverReference.constants.freeField.maxMultiLineTextLength}
    // TODO: Do we need to implement this? Does this even do anything?
    // style={{ fieldSizing: "content", minHeight: 100 }}
    rows={5}
  />;
};

export default FreefieldTextMultiLine;